import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Clock, Instagram, Facebook } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-800 text-white" data-id="element-126" data-mp="3ggk90wy2pg0l">
      <div className="container mx-auto px-4 py-12" data-id="element-127" data-mp="32oe281gt8ldt">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-128" data-mp="32lrk57wamnhc">
          {/* Footer Navigation */}
          <div data-id="element-129" data-mp="36nd5lhmw8a35">
            <h3 className="text-xl font-semibold mb-4" data-id="element-130" data-mp="3uf0p3ehtsive">Quick Links</h3>
            <ul className="space-y-2" data-id="element-131" data-mp="3uftmhouw9w0v">
              <li data-id="element-132" data-mp="38h5paxxbklh">
                <Link to="/" className="hover:text-burgundy-300 transition-colors" data-id="element-133" data-mp="38zbay6h7b62">
                  Home
                </Link>
              </li>
              <li data-id="element-134" data-mp="3qcnjcq32wkym">
                <Link to="/tips" className="hover:text-burgundy-300 transition-colors" data-id="element-135" data-mp="3qc3z32pyhkhf">
                  Tips
                </Link>
              </li>
              <li data-id="element-136" data-mp="2ezuvhqdesgnu">
                <Link to="/faq" className="hover:text-burgundy-300 transition-colors" data-id="element-137" data-mp="2ew71kq41xs8l">
                  FAQ
                </Link>
              </li>
              <li data-id="element-138" data-mp="3gcjvsqtw40gw">
                <Link to="/blogs" className="hover:text-burgundy-300 transition-colors" data-id="element-139" data-mp="3v7q2lg0t83ba">
                  Blogs
                </Link>
              </li>
              <li data-id="element-140" data-mp="82qthw25bzvb">
                <Link to="/about" className="hover:text-burgundy-300 transition-colors" data-id="element-141" data-mp="828q8fh2gldw">
                  About Us
                </Link>
              </li>
              <li data-id="element-142" data-mp="hrs9hm8oyh9a">
                <Link to="/contact" className="hover:text-burgundy-300 transition-colors" data-id="element-143" data-mp="hs1yb6i02ide">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-144" data-mp="qrfaw81f7n2c">
                <Link to="/standard-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-145" data-mp="mrwrjgp8zk1m">
                  Standard Lessons
                </Link>
              </li>
              <li data-id="element-146" data-mp="ytek6ham6csq">
                <Link to="/intensive-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-147" data-mp="yuzdy4p3trpj">
                  Intensive Lessons
                </Link>
              </li>
              <li data-id="element-148" data-mp="18m3nupzxamdi">
                <Link to="/additional-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-149" data-mp="1clupjoqzmmwt">
                  Additional Lessons
                </Link>
              </li>
              <li data-id="element-150" data-mp="1mktq0k1lnc8q">
                <Link to="/total-drive" className="hover:text-burgundy-300 transition-colors" data-id="element-151" data-mp="1mkbi2q5kr9kz">
                  Total Drive App
                </Link>
              </li>
            </ul>
          </div>
          {/* Operating Hours */}
          <div data-id="element-152" data-mp="3tb19tzyeyojm">
            <h3 className="text-xl font-semibold mb-4" data-id="element-153" data-mp="3tai2fd6e3iju">Operating Hours</h3>
            <ul className="space-y-2" data-id="element-154" data-mp="2ag5csk60p0dh">
              <li className="flex items-center gap-2" data-id="element-155" data-mp="2ah824nnoyura">
                <Clock size={16} data-id="element-156" data-mp="25nc8tyidhw2g" />
                <span data-id="element-157" data-mp="25mam2wrzvl4w">Monday - Thursday: 9:15 AM - 7:00 PM</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-158" data-mp="21nbj3hptpyg3">
                <Clock size={16} data-id="element-159" data-mp="1wo8qwxuxzmpj" />
                <span data-id="element-160" data-mp="1wp0ebledye4q">Friday: Closed</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-161" data-mp="2tehpuh01uuec">
                <Clock size={16} data-id="element-162" data-mp="2td6jqaj4tak2" />
                <span data-id="element-163" data-mp="2pcntgkww0cjz">Saturday - Sunday: 9:15 AM - 7:00 PM</span>
              </li>
            </ul>
          </div>
          {/* Customer Care */}
          <div data-id="element-164" data-mp="2kbqaw77ytghy">
            <h3 className="text-xl font-semibold mb-4" data-id="element-165" data-mp="2kbgn8qae7lff">Customer Care</h3>
            <ul className="space-y-2" data-id="element-166" data-mp="2fdf09u9uj1yo">
              <li className="flex items-center gap-2" data-id="element-167" data-mp="2fgkprame05ux">
                <Phone size={16} data-id="element-168" data-mp="18yxmn6edva6n" />
                <a href="tel:07481300600" className="hover:text-burgundy-300 transition-colors" data-id="element-169" data-mp="18w1obgymijho">
                  07481 300 600
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-170" data-mp="2wmg1z369m1ip">
                <Mail size={16} data-id="element-171" data-mp="2wo0rufhmwwa8" />
                <a href="mailto:info@northamptondrivingschool.co.uk" className="hover:text-burgundy-300 transition-colors" data-id="element-172" data-mp="2iv1fgmd5fi6w">
                  info@northamptondrivingschool.co.uk
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-4" data-id="element-173" data-mp="3bhm3pdybve68">
              <a href="#" aria-label="Facebook" className="hover:text-burgundy-300 transition-colors" data-id="element-174" data-mp="3fllldzvcgj16">
                <Facebook size={20} data-id="element-175" data-mp="36kne98plzved" />
              </a>
              <a href="#" aria-label="Instagram" className="hover:text-burgundy-300 transition-colors" data-id="element-176" data-mp="36jcd7gnjt1qy">
                <Instagram size={20} data-id="element-177" data-mp="1v603wq90rqxe" />
              </a>
            </div>
          </div>
        </div>
        {/* Created by Bright Pixxel Studio */}
        <div className="mt-8 flex justify-center" data-id="element-178" data-mp="1nk4o50pczirp">
          <a href="https://bright-pixxel.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors group" data-id="element-179" data-mp="1inny20ylmubz">
            <span className="text-sm" data-id="element-180" data-mp="1roccgwrwmwpe">Created by</span>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eufMZCrDQQvvNGVXgGvmTe/Logo_for_Bright_Pixxel_Studio.png" alt="Bright Pixxel Studio Logo" className="h-12 w-auto group-hover:opacity-90 transition-opacity" data-id="element-181" data-mp="13xgpqe2b2rp0" />
            <span className="text-sm font-medium" data-id="element-182" data-mp="18xbg8gi65f9j">Bright Pixxel Studio</span>
          </a>
        </div>
        <hr className="my-8 border-gray-700" data-id="element-183" data-mp="l77ekeojjpl6" />
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-184" data-mp="l5w8u9bjc7rf">
          <div className="text-sm text-gray-400 mb-4 md:mb-0 flex flex-col items-center md:items-start" data-id="element-185" data-mp="g7co2c8oh20n">
            <div data-id="element-186" data-mp="2g9u9rog023t7">
              <span data-id="element-187" data-mp="2gadhydfuldu1">
                <span className="text-burgundy-300" data-id="element-188" data-mp="2g8swreffb78u">N</span>orthampton{' '}
                <span className="text-burgundy-300" data-id="element-189" data-mp="2l7vt8ahc8557">D</span>riving{' '}
                <span className="text-burgundy-300" data-id="element-190" data-mp="2q1hvd8pvkqmr">S</span>chool
              </span>
            </div>
            <div className="mt-2" data-id="element-191" data-mp="2uyi2zo2di1fz">
              &copy; {new Date().getFullYear()} All rights reserved.
            </div>
          </div>
          <div className="flex flex-wrap gap-4 text-sm" data-id="element-192" data-mp="1xdvuw9by2244">
            <Link to="/privacy" className="hover:text-burgundy-300 transition-colors" data-id="element-193" data-mp="22bxc0opt7rcy">
              Privacy & Cookie Policy
            </Link>
            <Link to="/terms" className="hover:text-burgundy-300 transition-colors" data-id="element-194" data-mp="2bc2a28945deg">
              Terms & Conditions
            </Link>
            <Link to="/cancellation" className="hover:text-burgundy-300 transition-colors" data-id="element-195" data-mp="3mqplyv5cppxj">
              Cancellation, Health & Safety Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;